module.exports = __webpack_public_path__ + "static/media/29COICT10.4a71f2d0.jpg";